<template>
    <AuthenticatedLayout>
        <h1>Настройки</h1>

        <ConfirmDialog></ConfirmDialog>
        <Toast position="top-center" />

        <Card>
            <template #content>
                <div class="flex flex-row align-items-center mb-4">
                    <div class="text-xl w-14rem">Часовой пояс:</div>
                    <div class="w-15rem">
                        <Dropdown v-model="form.timezone" :options="timezones" optionLabel="timezone" placeholder="Выберите часовой пояс" disabled >
                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                                    {{slotProps.value}}
                                </div>
                                <span v-else>
                                    {{slotProps.placeholder}}
                                </span>
                            </template>
                            <template #option="slotProps">
                                <div>
                                    {{slotProps.option}}
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

<!--                <div class="flex flex-row align-items-center mb-4">-->
<!--                    <div class="text-xl w-14rem">Использовать все доступные USDT</div>-->
<!--                    <div class="flex flex-column align-items-start">-->
<!--                        <InputSwitch v-model="form.is_infinite_limit" ></InputSwitch>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="flex flex-column mb-4" v-if="!form.is_infinite_limit">-->
<!--                    <div class="flex flex-row align-items-center">-->
<!--                        <div class="text-xl w-14rem">Кошелёк USDT:</div>-->
<!--                        <div class="w-14rem p-inputgroup">-->
<!--                            <span class="p-inputgroup-addon">$</span>-->
<!--                            <InputText v-model="form.availableUsd" class="w-4rem"/>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="$page.props.errors.availableUsd" class="flex flex-row text-red-500 text-sm mt-1">-->
<!--                        <div class="w-14rem">&nbsp;</div><div>{{$page.props.errors.availableUsd}}</div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="flex flex-row align-items-center mb-1">-->
<!--                    <div class="text-xl w-14rem">Использовать сейф</div>-->
<!--                    <div class="flex flex-column align-items-start">-->
<!--                        <InputSwitch v-model="form.use_safe" ></InputSwitch>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="mb-4 text-sm text-gray-500">Если включено, вся полученная прибыль будет переводиться в сейф и выводиться из торговли.</div>-->

            </template>
        </Card>

        <div>
            <h2>Торговля</h2>
            <Card>
                <template #content>
                    <div v-if="form.is_disable_trade">
                        <div class="text-lg text-red-500 mb-3">Торговля для всего аккаунта остановлена</div>
                        <Button @click="switchTrade" label="Включить" class="p-button-info" />
                    </div>
                    <div v-else>
                        <div class="text-lg text-green-500 mb-3">Торговля глобально разрешена</div>
                        <Button @click="switchTrade" label="Остановить всех ботов" class="p-button-info" />
                    </div>
                </template>
            </Card>
        </div>

        <div v-for="exchange in exchangesForm" :key="exchange.id">
            <div class="flex flex-row align-items-baseline mt-4 mb-2">
                <div class="text-2xl mr-4">{{exchange.name}}</div>
                <div>
                    <div v-if="exchange.isConnected" class="text-green-600"><i class="pi pi-check mr-2"></i>соединение установлено</div>
                    <div v-else class="text-red-500"><i class="pi pi-exclamation-circle mr-2"></i>проверьте API-ключи</div>
                </div>
            </div>


            <Card>
                <template #content>

                    <div class="flex flex-row align-items-center mb-4">
                        <div class="text-xl w-14rem">Api Key:</div>
                        <div class="flex flex-column align-items-start">
                            <div class="flex flex-row align-items-center">
                                <div><InputText v-model="exchange.apiKey" class="w-30rem text-sm" /></div>
                            </div>
                            <div v-if="exchange.errors.apiKey" class="flex flex-row text-red-500 text-sm mt-1">
                                <div>{{exchange.errors.apiKey}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-row align-items-center mb-4">
                        <div class="text-xl w-14rem">Secret Key:</div>
                        <div class="flex flex-column align-items-start">
                            <div class="flex flex-row align-items-center">
                                <div><InputText v-model="exchange.secretKey" class="w-30rem text-sm" /></div>
                            </div>
                            <div v-if="exchange.errors.secretKey" class="flex flex-row text-red-500 text-sm mt-1">
                                <div>{{exchange.errors.secretKey}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-row align-items-center mb-4">
                        <div class="text-xl w-14rem"></div>
                        <div>
                            <SpinnerWrapper :loading="exchange.processing"><Button @click="storeExchange(exchange)" label="Сохранить" /></SpinnerWrapper>
                        </div>
                        <div>
                            <div v-if="$page.props.flash.success" class="text-green-500 ml-3">Настройки сохранены.</div>
                        </div>
                    </div>

                    <div class="flex flex-row align-items-center mb-4">
                        <div class="text-xl w-14rem"></div>
                        <ExchangeBalances :exchange="exchange" :server-ip="serverIp" @refresh="refreshExchanges" />
                    </div>


                </template>
            </Card>
        </div>

        <div>
            <div class="text-2xl mt-4 mb-2">Добавить биржу</div>
            <Card>
                <template #content>
                    <div>
                        <div class="flex flex-row align-items-center mb-4">
                            <div class="text-xl w-14rem">Биржа:</div>
                            <div class="flex flex-column align-items-start">
                                <div class="flex flex-row align-items-center">
                                    <div><Dropdown v-model="newExchange.exchangeId" :options="availableExchanges" optionLabel="name" optionValue="id" placeholder="Выберите биржу" /></div>
                                </div>
                                <div v-if="newExchange.errors.exchangeId" class="flex flex-row text-red-500 text-sm mt-1">
                                    <div>{{newExchange.errors.exchangeId}}</div>
                                </div>
                            </div>
                        </div>


                        <div class="flex flex-row align-items-center mb-4">
                            <div class="text-xl w-14rem">Api Key:</div>
                            <div class="flex flex-column align-items-start">
                                <div class="flex flex-row align-items-center">
                                    <div><InputText v-model="newExchange.apiKey" class="w-30rem text-sm" /></div>
                                </div>
                                <div v-if="newExchange.errors.apiKey" class="flex flex-row text-red-500 text-sm mt-1">
                                    <div>{{newExchange.errors.apiKey}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row align-items-center mb-4">
                            <div class="text-xl w-14rem">Secret Key:</div>
                            <div class="flex flex-column align-items-start">
                                <div class="flex flex-row align-items-center">
                                    <div><InputText v-model="newExchange.secretKey" class="w-30rem text-sm" /></div>
                                </div>
                                <div v-if="newExchange.errors.secretKey" class="flex flex-row text-red-500 text-sm mt-1">
                                    <div>{{newExchange.errors.secretKey}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row align-items-center mb-4">
                            <div class="text-xl w-14rem"></div>
                            <div>
                                <SpinnerWrapper :loading="newExchange.processing"><Button @click="addExchange" label="Сохранить" /></SpinnerWrapper>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>
        </div>



<!--        <div>-->
<!--            <h2>Перенос аккаунта на другой сервер</h2>-->
<!--            <Card>-->
<!--                <template #content>-->
<!--                    <span class="p-float-label mb-4">-->
<!--                        <InputText id="url" type="text" v-model="formTransfer.url" class="w-30rem"/>-->
<!--                        <label for="url">URL нового longardier-server</label>-->
<!--                    </span>-->
<!--                    <span class="p-float-label mb-4">-->
<!--                        <InputText id="login" type="text" v-model="formTransfer.login" class="w-30rem"/>-->
<!--                        <label for="login">Email пользователя на новом сервере</label>-->
<!--                    </span>-->
<!--                    <span class="p-float-label mb-4">-->
<!--                        <InputText id="password" type="password" v-model="formTransfer.password" class="w-30rem"/>-->
<!--                        <label for="password">Пароль пользователя на новом сервере</label>-->
<!--                    </span>-->
<!--                    <div class="mb-4">-->
<!--                        <Button @click="transferAccount" label="Перенести аккаунт" :loading="isTransfer" :loading-icon="'pi pi-spinner pi-spin'" />-->
<!--                    </div>-->
<!--                    <div v-html="resultTransfer"></div>-->

<!--                </template>-->
<!--            </Card>-->
<!--        </div>-->
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import SpinnerWrapper from "@/Components/SpinnerWrapper";
import InputSwitch from "primevue/inputswitch";
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import helpers from "@/helpers";
import { useForm } from '@inertiajs/vue2'
import { router } from '@inertiajs/vue2'
import ExchangeBalances from "@/Pages/Settings/ExchangeBalances.vue";

export default {
    components:{
        ExchangeBalances,
        InputSwitch,
        AuthenticatedLayout,
        Card, InputText, Dropdown, Button, SpinnerWrapper, ConfirmDialog, Toast, TabPanel, TabView
    },
    props:{
        timezones: Array,
        user: Object,
        serverIp: String,
        exchanges: Array,
        flash: Object,
        availableExchanges: Array
    },
    data(){
        return {
            form:{
                timezone: this.user.timezone,
                is_disable_trade: this.user.is_disable_trade,
            },
            isSaving: false,
            formTransfer: {
                url: '',
                login: '',
                password: ''
            },
            isTransfer: false,
            resultTransfer: '',

            activeTab: 0,
            newExchange: useForm({
                exchangeId: '',
                apiKey: '',
                secretKey: ''
            }),
            exchangesForm: {},
        }
    },
    mounted() {
        this.prepareExchangesForm();
    },
    watch:{
        flash(newFlash, oldFlash){
            if(newFlash.success !== null){
                this.$toast.add({severity:'success', summary: 'Success', detail: newFlash.success, life: 3000});
            }
            if(newFlash.error !== null){
                this.$toast.add({severity:'error', summary: 'Error', detail: newFlash.error, life: 5000});
            }
        }
    },
    computed: {

    },
    methods:{
        prepareExchangesForm(){
            this.exchanges.forEach((item) => {
                this.exchangesForm[item.exchangeId] = useForm({
                    exchangeId: item.exchangeId,
                    name: item.name,
                    apiKey: item.apiKey,
                    secretKey: item.secretKey,
                    isConnected: item.isConnected,
                    allBalances: item.allBalances
                });
            });
        },
        storeExchange(exchange){
            this.exchangesForm[exchange.exchangeId].post(`/settings/store_exchange`, {
                onSuccess: (page) => {
                    this.exchangesForm[exchange.exchangeId].clearErrors();
                }
            });
        },
        // transferAccount(){
        //     this.isTransfer = true;
        //     this.$inertia.post(`/settings/transfer`, this.formTransfer, {
        //         onSuccess: (page) => {
        //             this.isTransfer = false;
        //             this.resultTransfer = page.props.flash.success;
        //         }
        //     });
        // },
        switchTrade(){
            router.post(`/settings/switch_trade`, [], {
                onSuccess: (page) => {
                    this.form.is_disable_trade = page.props.user.is_disable_trade;
                }
            });
        },
        addExchange(){
            this.newExchange.post(`/settings/add_exchange`, {
                onSuccess: (page) => {
                    this.prepareExchangesForm();
                    this.newExchange.clearErrors();
                    this.newExchange.reset();
                },
                onError: (page) => {
                    console.log(this.newExchange.errors);
                },
            });
        },
        refreshExchanges(){
            console.log('refresh');
            this.prepareExchangesForm();
        },

        ...helpers
    }

}
</script>
